









/**
 * 海报生成方式： 服务端生成
 *
 */
import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import request from "@/api/index";
import native from "@/common/Native";
import { Toast } from "vant";
import {
  IPosterImageStrResonse,
  IPosterInfo,
  IPosterInfoResponse
} from "@/api/types";
@Component
export default class PosterV2 extends Vue {
  @Prop({ default: "" })
  infoClassifyId!: string;

  userInfo: any = {
    appId: "",
    sessionId: "",
    token: ""
  };
  posterTopImg: string = "";
  showPoster: boolean = false;
  posterInfo: IPosterInfo = {} as IPosterInfo;
  @Watch("infoClassifyId")
  infoClassifyIdChanged(value: string) {
    if (value) {
      this.initialPoster();
    }
  }

  mounted() {}
  initialPoster() {
    let isOpenInApp = false;
    isOpenInApp = native.isOpenInApp();
    // isOpenInApp = true;
    if (isOpenInApp) {
      native.getUserInfo().then((response: any) => {
        this.userInfo = response;
        this.toGenerateImage();
      });
    }
  }
  toGenerateImage() {
    let _this = this;
    new request()
      .getPosterInfo({
        sourceId: this.infoClassifyId,
        token: this.userInfo.token
      })
      .then((res: IPosterInfoResponse) => {
        if (res.code >= 0) {
          this.posterInfo = res.data;
          if (this.posterInfo.isPost == 1) {
            (window as any).generateImg = this.generateImg;
            //暴露关闭海报
            (window as any).doDismissPoster = () => {
              _this.showPoster = false;
            };
          }
        }
      });
  }
  generateImg() {
    // 防止重复绘制
    if (!this.posterTopImg) {
      Toast.loading({
        message: "海报生成中...",
        forbidClick: true
      });
      new request()
        .createPoster({
          postUrl: this.posterInfo.postUrl,
          gray: this.posterInfo.gray,
          title: this.posterInfo.title,
          detailUrl: this.posterInfo.detailUrl,
          loginStatus: this.userInfo.token ? "1" : "0",
          username: this.posterInfo.username,
          onlineTime: this.posterInfo.onlineTime,
          appId: this.posterInfo.appId
        })
        .then((res: IPosterImageStrResonse) => {
          if (res.code >= 0) {
            this.posterTopImg = res.data;
            this.showPoster = true;
            // 调用客户端调起海报保存方法
            ZWY_CLOUD.sharePlaybill({
              ImageAddress: this.posterTopImg
            });
          }
        })
        .finally(() => {
          Toast.clear();
        });
    } else {
      this.showPoster = true;
      // 调用客户端调起海报保存方法
      ZWY_CLOUD.sharePlaybill({
        ImageAddress: this.posterTopImg
      });
    }
  }
}
